import React from 'react';
import Home from './component/Home';
import Chat from './component/Chat';
import Auth from './component/Auth';
import Stats from './component/Stats';
import Leaderboard from './component/Leaderboard';
import ViewKingdom from './component/ViewKingdom';
import ProtectedRoute from './component/ProtectedRoute';
import ViewMembers from './component/ViewMembers';
import KdStats from './component/KdStats';
import WarHistory from './component/WarHistory';
import WarZone from './component/WarZone';
import PointsBreakup from './component/PointsBreakup';
import Welcome from './component/Welcome';
import Faq from './component/Faq';
import AvailableKingdom from './component/AvailableKingdom';
import FourZerofour from './component/FourZerofour';
import FiveZeroTwo from './component/FiveZeroTwo';
import AllKingdom from './component/AllKingdom';
import ViewKdAsRm from './component/ViewKdAsRm';
import ShareKingdom from './component/ShareKingdom';
import ComingSoon from './component/ComingSoon';
// import WarScore from './component/WarScore';
import WarScoreDetails from './component/WarScoreDetails';
import RmLeaderboard from './component/RmLeaderboard';
import KingdomLeaderboard from './component/KingdomLeaderboard';
import RegionHome from './component/RegionHome';
// import DistributorHome from './component/DistributorHome';
import BKBLeaderboard from './component/BKBLeaderboard';
import RmsLeaderboard from './component/RmsLeaderbord';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
/* import TestAnimation from './component/TestAnimation';
import MyComponent from './component/MyComponent';
import FinalHomePage from './component/FinalHomePage'; */
import HomePage from './component/HomePage';
import ImpactPlayerPage from './component/ImpactPlayerPage';
import WelcomeIw from './component/WelcomeIw';
import Bor from './component/Bor';
import MatchResult from './component/bor/MatchResult';
import Jarvis from './component/distributor-jarvis/Jarvis';

function App() {
	return (
		<Router>
			<div className="App">
				<Switch>
					<Route path="/auth/:enc?" exact component={Auth} />
					{/* <Route exact path="/" component={() => "502 USER NOT AUTHORISED"}/> */}
					<Route exact path="/" component={FiveZeroTwo} />
					<ProtectedRoute path="/welcome" exact component={Welcome} />
					<ProtectedRoute path="/home" component={Home} />
					<ProtectedRoute path="/faq/:show?" component={Faq} />
					<ProtectedRoute path="/chat" component={Chat} />
					<ProtectedRoute path="/available-kingdom" component={AvailableKingdom} />
					<ProtectedRoute path="/stats" component={Stats} />
					<ProtectedRoute path="/kingdom-stats" component={KdStats} />
					<ProtectedRoute path="/leaderboard" component={Leaderboard} />
					<ProtectedRoute path="/view-kingdom" component={ViewKingdom} />
					<ProtectedRoute path="/view-members" component={ViewMembers} />
					<ProtectedRoute path="/war-history" component={WarHistory} />
					<ProtectedRoute path="/war-zone" component={WarZone} />
					<ProtectedRoute path="/points-breakup" component={PointsBreakup} />
					<ProtectedRoute path="/all-kingdom" component={AllKingdom} />
					<ProtectedRoute path="/view-kingdom-rm" component={ViewKdAsRm} />
					<ProtectedRoute path="/share-kingdom" component={ShareKingdom} />
					<ProtectedRoute path="/coming-soon" component={ComingSoon} />
					{/* <ProtectedRoute path="/war-score" component={WarScore}/> */}
					<ProtectedRoute path="/war-score" component={Bor} />
					<ProtectedRoute path="/match-result" component={MatchResult} />
					<ProtectedRoute path="/war-score-details" component={WarScoreDetails} />
					<ProtectedRoute path="/rm-leaderboard" component={RmLeaderboard} />
					<ProtectedRoute path="/kingdom-leaderboard" component={KingdomLeaderboard} />
					<ProtectedRoute path="/region-home" component={RegionHome} />
					{/* <ProtectedRoute path="/distributor-home" component={DistributorHome}/> */}
					<ProtectedRoute path="/distributor-leaderboard" component={BKBLeaderboard} />
					<ProtectedRoute path="/rms-leaderboard" component={RmsLeaderboard} />
					{/* <ProtectedRoute path="/test-animation" component={MyComponent}/>
					<ProtectedRoute path="/my-component" component={MyComponent}/> */}
					{/* <ProtectedRoute path="/distributor-home" component={FinalHomePage}/> */}
					<ProtectedRoute path="/distributor-home" component={HomePage} />
					<ProtectedRoute path="/iw-home" component={ImpactPlayerPage} />
					<ProtectedRoute path="/welcome-iw/:show?" component={WelcomeIw} />

					<ProtectedRoute path="/distributor-jarvis" component={Jarvis} />

					{/* <ProtectedRoute path="/bor" component={Bor}/> */}
					{/* <Route path="*" component={() => "404 NOT FOUND"}/> */}
					<Route path="*" component={FourZerofour} />
				</Switch>
			</div>
		</Router>
	);
}

export default App;
